import {
  BBBright,
  BodyTextLStrong,
  BodyTextM,
  BodyTextMStrong,
  GRAY40,
  GRAY90,
  H3KR,
  SB,
} from 'global-styles';
import React from 'react';
import styled from 'styled-components';
import format from 'date-fns/format';
import { PostCategory, PostType } from 'react-query/blogApi';
import { useRouter } from 'next/router';

interface Props {
  category: PostCategory;
  title: string;
  author: string;
  publishedDate: string;
  postType: PostType;
}

const postTypeLabel = {
  'pulsar-avif': 'Pulsar-AVIF',
  'pulsar-av1': 'Pulsar-AV1',
  'pulsar-vmaf': 'Pulsar-VMAF',
  'deepfield-sr': 'DeepField-SR',
  'deepfield-pqo': 'DeepField-PQO',
  bluedot: 'BLUEDOT',
};

const PostMetaDataArea = ({
  category,
  title,
  author,
  publishedDate,
  postType,
}: Props) => {
  const dateTyped = new Date(publishedDate.slice(0, 10));
  const { locale } = useRouter();

  return (
    <PostMetaDataAreaContainer>
      {/* 제목, 카테고리 */}
      <div className="top-area">
        <BodyTextLStrong className="cat-name">{category}</BodyTextLStrong>
        <H3KR as="h2" className="title-t">
          {title}
        </H3KR>
      </div>

      {/* 날짜, 작성자, 제품명 */}
      <div className="bottom-area">
        <div className="date-author">
          <BodyTextM>
            {locale === 'en'
              ? format(dateTyped, 'yyyy-MM-dd')
              : format(dateTyped, 'yyyy년 MM월 dd일')}
          </BodyTextM>
          <BodyTextM>
            {locale === 'en' ? 'Writer' : '작성자'}: {author}
          </BodyTextM>
        </div>
        <BodyTextMStrong className="post-type">
          {postTypeLabel[postType.toLocaleLowerCase()]}
        </BodyTextMStrong>
      </div>
    </PostMetaDataAreaContainer>
  );
};

export default PostMetaDataArea;

const PostMetaDataAreaContainer = styled.section`
  margin-bottom: 32px;
  .top-area {
    padding-bottom: 32px;
    border-bottom: 1px solid ${GRAY90};
    margin-bottom: 16px;
  }
  .cat-name {
    color: ${SB};
    margin-bottom: 10px;
    text-transform: capitalize;
  }

  .date-author {
    margin-bottom: 4px;
    color: ${GRAY40};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .post-type {
    text-align: right;
    color: ${BBBright};
    text-transform: capitalize;
  }
  @media screen and (max-width: 1239px) {
    margin-bottom: 16px;
  }

  @media screen and (max-width: 599px) {
    margin-bottom: 8px;
    .top-area {
      padding-bottom: 16px;
    }
  }
`;
